import React from 'react'
import packageJson from '../package.json'
import manifestJson from '../public/manifest.json';

global.appVersion = packageJson.version
const BASE_URL = manifestJson.config.baseURI;
const url = `${BASE_URL}/api/version/oz`;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g)

    const versionsB = versionB.split(/\./g)
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift())

        const b = Number(versionsB.shift())
        // eslint-disable-next-line no-continue
        if (a === b) continue
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b)
    }
    return false
}

class CacheBuster extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log('Clearing cache and hard reloading...')
                if (window.caches) {
                    const { caches } = window;
                    // Service worker cache should be cleared with caches.delete()
                    caches.keys().then(async function (names) {
                        await Promise.all(names.map(name => caches.delete(name)))
                    })
                }

                // delete browser cache and hard reload
                window.location.reload(true)
            }
        }
    }

    componentDidMount() {
        // Call this function so that it fetch first time right after mounting the component
        this.fetchVersion();

        // set Interval
        this.interval = setInterval(this.fetchVersion, 60 * 60 * 1000);
    }

    componentWillUnmount() {
        // Clear the interval right before component unmount
        clearInterval(this.interval);
    }

    fetchVersion = () => {
        console.warn('fetching version');
        fetch(url)
            .then((response) => response.json())
            .then((config) => {
                const latestVersion = config.value
                const currentVersion = global.appVersion

                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion)
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`)
                    this.setState({ loading: false, isLatestVersion: false })
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`)
                    this.setState({ loading: false, isLatestVersion: true })
                }
            }).catch(e => {
                this.setState({ loading: false, isLatestVersion: true })
            })
    }

    render() {
        const { loading, isLatestVersion, refreshCacheAndReload } = this.state
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload })
    }
}

export default CacheBuster



// WEBPACK FOOTER //
// ./src/cacheBuster.js